import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { z } from 'zod';
import { zodSelectEmail } from '../generated/zodSchemas.generated';

export const ZEmailSelectPrivate = zodSelectEmail
  .pick({
    id: true,
    playerId: true,
    state: true,
    templateName: true,
    templateData: true,
    unsubscribed: true,
  })
  .extend(
    ensureSubsetOfKeys(zodSelectEmail.shape, {
      createdAt: z.coerce.date().nullable(),
      lastModified: z.coerce.date().nullable(),
    }),
  );

export type TEmailSelectPrivate = z.infer<typeof ZEmailSelectPrivate>;
